export default {
  emailValidation: /^[A-Z0-9._%+-Ñ]+@[A-Z0-9.-Ñ]+\.[A-Z]{2,4}$/i,
  hourValidation: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, // hh:mm
  languageFieldName: /lang\d{1,2}$/g
}
